import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.group.item');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import showdown from 'showdown';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-gsdcuser-group-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.group.item/view.scss */
/* src/app/portal.gsdcuser.group.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserGroupItemComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    @Input() group_id: any;
    public loading = true;
    public loadError = '';
    public loadCode = 0;
    public membersLoading = true;
    public membersFailed = false;
    public group: any = null;
    public community: any = null;
    public users: any = [];
    public leaving: boolean = false;
    public changingPI = false;
    public get canManagePI() {
        return this.service.auth.session?.role !== 'manager' && this.group?.can_manage_pi === true;
    }
    private membersRequest = 0;

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1
    }
    public searchTerm: any = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        if (await this.load() === false) return;
        await this.groupUsers();
    }

    public async reload() {
        if (await this.load() !== false) await this.groupUsers();
    }
    public async load() {
        this.loading = true;
        this.loadError = '';
        this.loadCode = 0;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("info", { id: this.group_id }, { timeout: 15000 });
            if (code !== 200) {
                this.loadCode = code;
                throw new Error('load');
            }
            if (!data?.info || !data?.community) throw new Error('load');
            this.group = data.info;
            this.community = data.community;
            return true;
        } catch (_) {
            this.loadError = this.loadCode === 403 ? '이 그룹을 조회할 권한이 없습니다.'
                : this.loadCode === 404 ? '그룹을 찾을 수 없습니다.' : '그룹 정보를 불러오지 못했습니다.';
            return false;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async groupUsers() {
        const request = ++this.membersRequest;
        this.membersLoading = true;
        this.membersFailed = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("groupUsers", {
                groupID: this.group_id,
                communityID: this.community.id,
                page: this.pagination.page,
                text: this.searchTerm
            }, { timeout: 15000 });
            if (request !== this.membersRequest) return;
            if (code !== 200 || !Array.isArray(data?.rows)) throw new Error('load');
            this.pagination.page = data.page || this.pagination.page;
            this.users = data.rows;
            this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
            this.pagination.end = data.lastpage;
            this.total = data.total;
        } catch (_) {
            if (request === this.membersRequest) this.membersFailed = true;
        } finally {
            if (request === this.membersRequest) {
                this.membersLoading = false;
                await this.service.render();
            }
        }
    }

    public async changePI(user: any) {
        if (!this.canManagePI || this.changingPI) return;
        this.changingPI = true;
        const representative = user.representative === 'Y' ? 'N' : 'Y';
        try {
            const confirmed = await this.service.alert.success(
                representative === 'Y' ? '그룹 대표(PI)로 지정하시겠습니까?' : '그룹 대표(PI)를 해제하시겠습니까?', '취소');
            if (!confirmed) return;
            const { code, data } = await wiz.call('changePI', {
                group_id: this.group_id,
                user: JSON.stringify({ id: user.id, member_id: user.member_id, representative })
            });
            if (code != 200) {
                if (code === 403) this.group.can_manage_pi = false;
                await this.service.alert.error(data?.message || '그룹 대표 변경을 완료하지 못했습니다.');
                return;
            }
            user.representative = representative;
            if (data?.message) await this.service.alert.success(data.message);
            if (await this.load() !== false) await this.groupUsers();
        } catch (_) {
            await this.service.alert.error('그룹 대표 변경 결과를 확인하지 못했습니다. 다시 조회해주세요.');
            try {
                if (await this.load() !== false) await this.groupUsers();
            } catch (_) { /* Keep the last confirmed state until the page can reload. */ }
        } finally {
            this.changingPI = false;
            await this.service.render();
        }
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async leaveGroup() {
        if (this.leaving) return;
        if (!this.group?.can_leave) return await this.service.alert.error(this.group?.leave_disabled_reason || "이 그룹에서는 탈퇴할 수 없습니다.");
        this.leaving = true;
        let loading = false;
        try {
            const confirmed = await this.service.alert.error(`"${this.group.name}" 그룹에서 탈퇴하시겠습니까?`, "취소", "탈퇴");
            if (!confirmed) return;
            this.service.loading.show();
            loading = true;
            let response;
            try {
                response = await wiz.call("leave_group", { group_id: this.group_id });
            } finally {
                this.service.loading.hide();
                loading = false;
            }
            const { code, data } = response;
            if (code != 200) return await this.service.alert.error(data?.message || "그룹 탈퇴를 완료하지 못했습니다. 다시 시도해주세요.");
            this.group.can_leave = false;
            await this.service.alert.success(data?.message || "그룹에서 탈퇴했습니다.");
            await this.router.navigate(['/group/list']);
        } catch (error) {
            await this.service.alert.error("그룹 탈퇴 결과를 확인하지 못했습니다. 같은 그룹으로 다시 시도해주세요.");
        } finally {
            if (loading) this.service.loading.hide();
            this.leaving = false;
            await this.service.render();
        }
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.groupUsers();
    }
}

export default PortalGsdcuserGroupItemComponent;